query AnalyticsUsersByUtm($filter: AnalyticsUsersFilterInput!, $dimension: UtmDimension!) {
  analyticsUsers(filter: $filter) {
    usersByUtm(dimension: $dimension) {
      value
      users
    }
  }
}
